import _ from 'lodash';
import {FETCH_SINGLE_CATEGORY} from '../actions';

export default function (state={}, action){
  switch(action.type){
    case FETCH_SINGLE_CATEGORY:
      return _.mapKeys(action.payload.data, 'id');
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_singleCategory.js